import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  convertImage,
  formatBytes,
  getFileExtension,
  readFile,
  saveFile,
} from "../Utils";
import ImageScaleType from "./ImageScaleType";
import ImageDrawMode from "./ImageDrawMode";
import ImageViewerView from "../image_viewer/ImageViewerView";

function ImageConverterImageListScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //fileinfo list
  //store thumbnail, page count etc key is filepath
  const [filesInfo, setFilesInfo] = useState({});
  //output settings
  const [outputSettings, setOutputSettings] = useState({
    type: {
      popupShowing: false,
      export_as: ".jpg",
      mimetype: "image/jpeg",
    },
    quality: 80, //output image quality
    scaleType: { scale_type: ImageScaleType.NONE, popupShowing: false }, //how to scale output resolution}
    imageDimension: {
      width: 1024,
      height: 1024,
      draw_mode: ImageDrawMode.SCAlE_TO_FILL,
      popupShowing: false,
    }, //image dimension
    scale: 100,
    grayscale: false,
  });
  //is converting
  const [isConverting, setIsConverting] = useState(false);

  //show image preview
  const [showImagePreview, setShowImagePreview] = useState({
    preview: false,
    file: null,
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //generate thumbnails
      generateThumbnails();

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles]);

  //generate thumbnails
  const generateThumbnails = async () => {
    //loop
    //read files
    //get thumbnails
    for (let i = 0; i < selectedFiles.length; i++) {
      //selected file
      const selectedFile = selectedFiles[i];
      //path pdf file
      const key = String(selectedFile.path);
      //image blob
      const imgBlob = await readFile(selectedFile);
      //set image
      setFilesInfo((prevDictionary) => ({
        ...prevDictionary,
        [key]: {
          ...filesInfo[key],
          state: AppState.LOADED,
          thumbnail: URL.createObjectURL(imgBlob),
          message: "",
          name: selectedFile.name,
          file: selectedFile, //selected file
          size: selectedFile.size, //in bytes
          converter_blob: null,
          converter_size: 0,
        },
      }));
    }
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setFilesInfo({});
    setStartProcessingFiles(false);
  };

  //on chnage checkbox values
  const onChangeCheckboxValues = (e) => {
    //set
    setOutputSettings({
      ...outputSettings,
      grayscale: e.target.checked,
    });
  };

  //on chnage image quality
  const onChangeOutputImageDimension = (e) => {
    //set
    setOutputSettings({
      ...outputSettings,
      imageDimension: {
        ...outputSettings.imageDimension,
        [e.target.id]: e.target.value,
      },
    });
  };

  //on chnage image scale
  const onChangeOutputImageScale = (e) => {
    //set
    setOutputSettings({ ...outputSettings, scale: e.target.value });
  };

  //on chnage image quality
  const onChangeOutputImageQuality = (e) => {
    //set
    setOutputSettings({ ...outputSettings, quality: e.target.value });
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div
        className="mt-3"
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //show preview
          setShowImagePreview({
            ...showImagePreview,
            preview: true,
            file:
              filesInfo[String(item.path)].converter_blob === null
                ? filesInfo[String(item.path)].file
                : filesInfo[String(item.path)].converter_blob,
          });
        }}
      >
        {/* Flex container left image pdf right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].thumbnail != null
                      ? filesInfo[String(item.path)].thumbnail
                      : "./images/file_icon.png"
                    : "./images/file_icon.png"
                }
                alt="pdf_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size:{" "}
                {String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? formatBytes(filesInfo[String(item.path)].converter_size)
                    : formatBytes(item.size)
                  : formatBytes(0)}
              </div>
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].state === AppState.PROCESSED
                      ? "text-success"
                      : "bg-danger text-white"
                    : "bg-danger text-white"
                }`}
              >
                {String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? "CONVERTED"
                    : getFileExtension(item.name.toUpperCase())
                  : getFileExtension(item.name.toUpperCase())}
              </div>
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].message !== ""
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {String(item.path) in filesInfo
                ? filesInfo[String(item.path)].message
                : ""}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          {/* Download Button */}
          {/* Show download button after processed */}
          <div
            className="position-absolute  justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={async (e) => {
                  //stop propagating
                  e.stopPropagation();
                  //check
                  if (String(item.path) in filesInfo === true) {
                    //blob
                    const blob = filesInfo[String(item.path)].converter_blob;
                    //save
                    await saveFile(blob, filesInfo[String(item.path)].name);
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-download"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                </svg>
              </button>
            </div>
            {/* Show spinner while processing */}
            {/* Spinner */}
            <div
              className={`spinner-border my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSING
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.LOADED ||
                    filesInfo[String(item.path)].state === AppState.NONE
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                  //remove thumbnails
                  setFilesInfo((currentData) => {
                    // Destructure the key to remove into a throwaway variable (e.g., '_')
                    // and collect the rest of the properties into a new object 'rest'
                    const { [String(item.path)]: _, ...rest } = currentData;
                    //return
                    return rest;
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* show pdf preview */}
      {/* page main content */}
      {showImagePreview.preview ? (
        <ImageViewerView
          title={
            showImagePreview.file === null ? "" : showImagePreview.file.name
          }
          onClose={() => {
            //set preview
            setShowImagePreview({
              ...showImagePreview,
              preview: false,
              file: null,
            });
          }}
          file={showImagePreview.file}
        ></ImageViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title ?? "Convert Images, Compress Images"}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1  border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {/* output settings */}
              <div className="mt-5 ms-4  me-4">
                {/* Label */}
                <div className="border-bottom pb-2">
                  <label
                    htmlFor="output_setting_label"
                    className="form-label fs-4 text-dark"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Output file type, resolution, quality"
                  >
                    Output Settings:
                  </label>
                </div>

                {/* Output image file type */}
                <div className="d-flex mt-5 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Export as:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenuImageType"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //toggle
                        setOutputSettings({
                          ...outputSettings,
                          type: {
                            ...outputSettings.type,
                            popupShowing:
                              outputSettings.type.popupShowing === true
                                ? false
                                : true,
                          },
                          imageDimension: {
                            ...outputSettings.imageDimension,
                            popupShowing: false,
                          },
                          scaleType: {
                            ...outputSettings.scaleType,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {outputSettings.type.export_as}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        outputSettings.type.popupShowing === true ? "show" : ""
                      }`}
                      aria-labelledby="dropdownMenuImageType"
                    >
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".jpg",
                              mimetype: "image/jpg",
                            },
                            imageDimension: {
                              ...outputSettings.imageDimension,
                              popupShowing: false,
                            },
                            scaleType: {
                              ...outputSettings.scaleType,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .jpg
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".jpeg",
                              mimetype: "image/jpeg",
                            },
                            imageDimension: {
                              ...outputSettings.imageDimension,
                              popupShowing: false,
                            },
                            scaleType: {
                              ...outputSettings.scaleType,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .jpeg
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".png",
                              mimetype: "image/png",
                            },
                            imageDimension: {
                              ...outputSettings.imageDimension,
                              popupShowing: false,
                            },
                            scaleType: {
                              ...outputSettings.scaleType,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .png
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".bmp",
                              mimetype: "image/bmp",
                            },
                            imageDimension: {
                              ...outputSettings.imageDimension,
                              popupShowing: false,
                            },
                            scaleType: {
                              ...outputSettings.scaleType,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .bmp
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".webp",
                              mimetype: "image/webp",
                            },
                            imageDimension: {
                              ...outputSettings.imageDimension,
                              popupShowing: false,
                            },
                            scaleType: {
                              ...outputSettings.scaleType,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .webp
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".svg",
                              mimetype: "image/svg+xml",
                            },
                            imageDimension: {
                              ...outputSettings.imageDimension,
                              popupShowing: false,
                            },
                            scaleType: {
                              ...outputSettings.scaleType,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .svg
                      </button>
                    </div>
                  </div>
                </div>

                {/* Image Quality */}
                <div className="d-flex mt-2">
                  {/* Quality label */}
                  <label className="fs-6 me-2 my-auto text-secondary">
                    Quality:
                  </label>
                  {/* Quality slider */}
                  <div className="my-auto pt-2">
                    <input
                      type="range"
                      className="form-range"
                      min={10}
                      max={100}
                      value={outputSettings.quality}
                      id="image_quality"
                      onChange={onChangeOutputImageQuality}
                    ></input>
                  </div>
                  <label className="fs-6 text-success ms-2 my-auto d-sm-block d-none">
                    {Math.floor(outputSettings.quality) + "%"}
                  </label>
                </div>

                {/* Image dimention type */}
                <div className="d-flex mt-4 my-auto">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Size:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenuScaleImage"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //toggle
                        setOutputSettings({
                          ...outputSettings,
                          scaleType: {
                            ...outputSettings.scaleType,
                            popupShowing:
                              outputSettings.scaleType.popupShowing === true
                                ? false
                                : true,
                          },
                          type: { ...outputSettings.type, popupShowing: false },
                          imageDimension: {
                            ...outputSettings.imageDimension,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {outputSettings.scaleType.scale_type}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        outputSettings.scaleType.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenuScaleImage"
                    >
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            scaleType: {
                              ...outputSettings.scaleType,
                              popupShowing: false,
                              scale_type: ImageScaleType.SCALE,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            imageDimension: {
                              ...outputSettings.imageDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {ImageScaleType.SCALE}
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            scaleType: {
                              ...outputSettings.scaleType,
                              popupShowing: false,
                              scale_type: ImageScaleType.FIXED,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            imageDimension: {
                              ...outputSettings.imageDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {ImageScaleType.FIXED}
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            scaleType: {
                              ...outputSettings.scaleType,
                              popupShowing: false,
                              scale_type: ImageScaleType.NONE,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            imageDimension: {
                              ...outputSettings.imageDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {ImageScaleType.NONE}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Fixed size */}
                <div
                  className={`mt-4 bg-light p-2 rounded-2 ${
                    outputSettings.scaleType.scale_type === ImageScaleType.FIXED
                      ? ""
                      : "d-none"
                  }`}
                >
                  {/* Image width input*/}
                  <div className="d-flex">
                    {/* width label */}
                    <label className="fs-6 me-2 my-auto text-secondary">
                      Width (px):
                    </label>
                    {/* width input */}
                    <input
                      className="form-control"
                      type="number"
                      placeholder="width px"
                      id="width"
                      style={{ width: "80px" }}
                      value={outputSettings.imageDimension.width}
                      onChange={onChangeOutputImageDimension}
                    />
                  </div>
                  {/* Image height input*/}
                  <div className="d-flex mt-2">
                    {/* height label */}
                    <label className="fs-6 me-2 my-auto text-secondary">
                      Height (px):
                    </label>
                    {/* height input */}
                    <input
                      className="form-control"
                      type="number"
                      placeholder="width px"
                      id="height"
                      style={{ width: "80px" }}
                      value={outputSettings.imageDimension.height}
                      onChange={onChangeOutputImageDimension}
                    />
                  </div>

                  {/* Draw mode */}
                  <div className="d-flex mt-4 my-auto text-center">
                    {/* Label */}
                    <label className="fs-6 me-2 text-secondary">
                      Draw Mode:
                    </label>
                    {/* Dropdown menu */}
                    <div className="dropdown">
                      <label
                        className="dropdown-toggle fs-6 text-primary"
                        type="text"
                        id="dropdownMenuDrawMode"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          //toggle
                          setOutputSettings({
                            ...outputSettings,
                            imageDimension: {
                              ...outputSettings.imageDimension,
                              popupShowing:
                                outputSettings.imageDimension.popupShowing ===
                                true
                                  ? false
                                  : true,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            scaleType: {
                              ...outputSettings.scaleType,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {outputSettings.imageDimension.draw_mode}
                      </label>
                      <div
                        className={`dropdown-menu ${
                          outputSettings.imageDimension.popupShowing === true
                            ? "show"
                            : ""
                        }`}
                        aria-labelledby="dropdownMenuDrawMode"
                      >
                        <button
                          className="dropdown-item"
                          type="button"
                          onClick={(e) => {
                            //set configuration
                            setOutputSettings({
                              ...outputSettings,
                              imageDimension: {
                                ...outputSettings.imageDimension,
                                popupShowing: false,
                                draw_mode: ImageDrawMode.SCAlE_TO_FILL,
                              },
                              type: {
                                ...outputSettings.type,
                                popupShowing: false,
                              },
                              scaleType: {
                                ...outputSettings.scaleType,
                                popupShowing: false,
                              },
                            });
                          }}
                        >
                          {ImageDrawMode.SCAlE_TO_FILL}
                        </button>
                        <button
                          className="dropdown-item"
                          type="button"
                          onClick={(e) => {
                            //set configuration
                            setOutputSettings({
                              ...outputSettings,
                              imageDimension: {
                                ...outputSettings.imageDimension,
                                popupShowing: false,
                                draw_mode: ImageDrawMode.ASPECT_FILL,
                              },
                              type: {
                                ...outputSettings.type,
                                popupShowing: false,
                              },
                              scaleType: {
                                ...outputSettings.scaleType,
                                popupShowing: false,
                              },
                            });
                          }}
                        >
                          {ImageDrawMode.ASPECT_FILL}
                        </button>
                        <button
                          className="dropdown-item"
                          type="button"
                          onClick={(e) => {
                            //set configuration
                            setOutputSettings({
                              ...outputSettings,
                              imageDimension: {
                                ...outputSettings.imageDimension,
                                popupShowing: false,
                                draw_mode: ImageDrawMode.ASPECT_FIT,
                              },
                              type: {
                                ...outputSettings.type,
                                popupShowing: false,
                              },
                              scaleType: {
                                ...outputSettings.scaleType,
                                popupShowing: false,
                              },
                            });
                          }}
                        >
                          {ImageDrawMode.ASPECT_FIT}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Scale image */}
                <div
                  className={`d-flex mt-4 bg-light p-2 rounded-2 ${
                    outputSettings.scaleType.scale_type === ImageScaleType.SCALE
                      ? ""
                      : "d-none"
                  }`}
                >
                  {/* Scale label */}
                  <label className="fs-6 me-2 my-auto text-secondary">
                    Scale:
                  </label>
                  {/* Scale slider */}
                  <div className="my-auto pt-2">
                    <input
                      type="range"
                      className="form-range"
                      min={10}
                      max={100}
                      value={outputSettings.scale}
                      id="image_scale"
                      onChange={onChangeOutputImageScale}
                    ></input>
                  </div>
                  <label className="fs-6 text-success ms-2 my-auto  d-sm-block d-none">
                    {Math.floor(outputSettings.scale) + "%"}
                  </label>
                </div>

                {/* Checkbox Grayscale */}
                <div className="mt-4">
                  <label className="text-secondary" htmlFor="grayscale">
                    Grayscale(B/W)
                  </label>
                  <input
                    className="form-check-input ms-2 "
                    type="checkbox"
                    value=""
                    checked={outputSettings.grayscale}
                    id="grayscale"
                    onChange={onChangeCheckboxValues}
                  />
                </div>
              </div>

              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isConverting ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                }}
                type="button"
                onClick={async (e) => {
                  //hide all dropdown
                  //set configuration
                  setOutputSettings({
                    ...outputSettings,
                    imageDimension: {
                      ...outputSettings.imageDimension,
                      popupShowing: false,
                    },
                    type: { ...outputSettings.type, popupShowing: false },
                    scaleType: {
                      ...outputSettings.scaleType,
                      popupShowing: false,
                    },
                  });
                  //set
                  setIsConverting(true);
                  //loop
                  for (let i = 0; i < selectedFiles.length; i++) {
                    //selected file
                    const selectedFile = selectedFiles[i];
                    //path pdf file
                    const key = String(selectedFile.path);

                    //convert images
                    const imgBlob = await convertImage(selectedFile, {
                      mimetype: outputSettings.type.mimetype,
                      quality: outputSettings.quality / 100, // 0 - 1
                      scaleType: outputSettings.scaleType.scale_type,
                      grayscale: outputSettings.grayscale,
                      scale: outputSettings.scale / 100, // 0 - 1
                      width: outputSettings.imageDimension.width,
                      height: outputSettings.imageDimension.height,
                      drawMode: outputSettings.imageDimension.draw_mode,
                    });

                    //set blob
                    setFilesInfo((prevDictionary) => ({
                      ...prevDictionary,
                      [key]: {
                        ...filesInfo[key],
                        state: AppState.PROCESSED,
                        message: `Successfully converted image. Click on download button to save.`,
                        converter_blob:
                          imgBlob === null ? selectedFile : imgBlob,
                        converter_size:
                          imgBlob === null ? selectedFile.size : imgBlob.size,
                      },
                    }));
                  }
                  //reset
                  setIsConverting(false);
                }}
              >
                CONVERT
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ImageConverterImageListScreen;
